// extracted by mini-css-extract-plugin
export default {"status":"StatusMessage_status__+j8rE","error":"StatusMessage_error__+psYS"};